module.exports = __webpack_public_path__ + "img/appAsset-http--404-ax.dff48646.svg";